import React, { useState } from "react";
import { NavbarBusiness } from "../components/navbar/indexBusiness";
import { SidebarB } from "../components/sidebar/indexB";

// import Image7 from "../images/DC4.png";
import Footer from "../components/footer";
// import Contact from "../components/contact";

// import Image7 from "../images/cp1.png";
import Services1 from "../components/services1";
// import Footer from "../components/footer";
// import CardP from "../components/cards/CardP";



const Boards = () => {
    const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
    <SidebarB isOpen={isOpen} toggle={toggle} />
    <NavbarBusiness toggle={toggle} />
  

      {/* <CardP id="about"/> */}

      <Services1 />

      {/* <Contact image={Image7} id="Contact" title="Contact US" /> */}

    <Footer />
  </>
);
};

export default Boards;